(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (root, smoothScroll) {
  'use strict';

  // Support RequireJS and CommonJS/NodeJS module formats.
  // Attach smoothScroll to the `window` when executed as a <script>.

  // RequireJS
  if (typeof define === 'function' && define.amd) {
    define(smoothScroll);

  // CommonJS
  } else if (typeof exports === 'object' && typeof module === 'object') {
    module.exports = smoothScroll();

  } else {
    root.smoothScroll = smoothScroll();
  }

})(this, function(){
'use strict';

// Do not initialize smoothScroll when running server side, handle it in client:
if (typeof window !== 'object') return;

// We do not want this script to be applied in browsers that do not support those
// That means no smoothscroll on IE9 and below.
if(document.querySelectorAll === void 0 || window.pageYOffset === void 0 || history.pushState === void 0) { return; }

// Get the top position of an element in the document
var getTop = function(element, start) {
    // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
    if(element.nodeName === 'HTML') return -start
    return element.getBoundingClientRect().top + start
}
// ease in out function thanks to:
// http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
var easeInOutCubic = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }

// calculate the scroll position we should be in
// given the start and end point of the scroll
// the time elapsed from the beginning of the scroll
// and the total duration of the scroll (default 500ms)
var position = function(start, end, elapsed, duration) {
    if (elapsed > duration) return end;
    return start + (end - start) * easeInOutCubic(elapsed / duration); // <-- you can change the easing funtion there
    // return start + (end - start) * (elapsed / duration); // <-- this would give a linear scroll
}

// we use requestAnimationFrame to be called by the browser before every repaint
// if the first argument is an element then scroll to the top of this element
// if the first argument is numeric then scroll to this location
// if the callback exist, it is called when the scrolling is finished
// if context is set then scroll that element, else scroll window
var smoothScroll = function(el, duration, callback, context){
    duration = duration || 500;
    context = context || window;
    var start = context.scrollTop || window.pageYOffset;

    if (typeof el === 'number') {
      var end = parseInt(el);
    } else {
      var end = getTop(el, start);
    }

    var clock = Date.now();
    var requestAnimationFrame = window.requestAnimationFrame ||
        window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
        function(fn){window.setTimeout(fn, 15);};

    var step = function(){
        var elapsed = Date.now() - clock;
        if (context !== window) {
          context.scrollTop = position(start, end, elapsed, duration);
        }
        else {
          window.scroll(0, position(start, end, elapsed, duration));
        }

        if (elapsed > duration) {
            if (typeof callback === 'function') {
                callback(el);
            }
        } else {
            requestAnimationFrame(step);
        }
    }
    step();
}

var linkHandler = function(ev) {
    if (!ev.defaultPrevented) {
        ev.preventDefault();

        if (location.hash !== this.hash) window.history.pushState(null, null, this.hash)
        // using the history api to solve issue #1 - back doesn't work
        // most browser don't update :target when the history api is used:
        // THIS IS A BUG FROM THE BROWSERS.
        // change the scrolling duration in this call
        var node = document.getElementById(this.hash.substring(1))
        if (!node) return; // Do not scroll to non-existing node

        smoothScroll(node, 500, function (el) {
            location.replace('#' + el.id)
            // this will cause the :target to be activated.
        });
    }
}

// We look for all the internal links in the documents and attach the smoothscroll function
document.addEventListener("DOMContentLoaded", function () {
    var internal = document.querySelectorAll('a[href^="#"]:not([href="#"])'), a;
    for(var i=internal.length; a=internal[--i];){
        a.addEventListener("click", linkHandler, false);
    }
});

// return smoothscroll API
return smoothScroll;

});

},{}],2:[function(require,module,exports){
const kenburnsInit = () => {
    // this check is to make sure kenburns do not start when not required.
    if(!$('.kenburn-hero').length){
        return false;
    }

    const initKenburn = () => {
        $('.kenburns').attr('width', $('.kenburns').parent('.kenburn-section').width());
        $('.kenburns').attr('height', $('.kenburns').parent('.kenburn-section').height());
        $('.kenburns').each((index, elem) => {
            $(elem).kenburns({
                images: $(elem).data('imgs'),
                frames_per_second: 30,
                display_time: 8000,
                fade_time: 1500,
                zoom: 1.1,
                background_color: '#000000'
            });
        });
    
    
        // initialize kenburns slider
        $('.kenburn-hero.slider').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `<a type="button" class="slick-prev"></a>`,
            nextArrow: `<a type="button" class="slick-next"></a>`,
            dots: true,
            swipeToSlide: true,
            arrows: true,
            pauseOnHover: false,
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    arrows: false,
                  }
                }
            ]
        });
    }

    initKenburn();

    $(window).resize($.debounce(750, function(){
        $('.kenburns').kenburnsDestroy();
        initKenburn();
    }));
}

// expose to allow to be triggered from jarvis
window.kenburnsInit = kenburnsInit;

module.exports = kenburnsInit;

},{}],3:[function(require,module,exports){
module.exports = {
    highlightWhenVisible: (selector) => {
        $(window).on('scroll', e => {
            const scroll = $(e.currentTarget).scrollTop();
            selector.each((index, element) => {
                const objecttop = $(element).offset().top - 250;
                const objectbottom = objecttop + $(element).outerHeight() - 100;
                if (scroll >= objecttop && scroll<= objectbottom) {
                    selector.removeClass('active');
                    $(element).addClass("active");
                }
            });
        });
    },

    initVideoBg: () => {
		let count = 0;
		$('.player').each((index, element) => {
            $(element).parent().attr('id', 'banner_module_' + count);
            $(element).YTPlayer({
				containment: '#' + 'banner_module_' + count
			});
            count ++;
            // this needs to be fixed in a better way. It forces YTPlayer to resize video size and hence resolves the initial size issue of YTPlayer video in
			$(window).resize();
		});
	},

    initScrollReveal: () => {
        const $window = $(window);
        const win_height_padded = $window.height() * 1.1;
        const isTouch = Modernizr.touch;

        if (isTouch) $('.revealOnScroll').addClass('animated');

        const revealOnScroll = () => {
            const scrolled = $window.scrollTop();
            const win_height_padded = $window.height() * 1.1;

            $(".revealOnScroll:not(.animated)").each((index, element) => {
                const $this = $(element);
                const offsetTop = $this.offset().top;
                if (scrolled + win_height_padded > offsetTop) {
                    if ($this.data('timeout')) {
                        setTimeout(() => {
                            $this.addClass('animated ' + $this.data('animation'));
                        }, parseInt($this.data('timeout'),10));
                    } else {
                        $this.addClass('animated ' + $this.data('animation'));
                    }
                }
            });

            $(".revealOnScroll.animated").each((index, element) => {
                const $this = $(element);
                const offsetTop = $this.offset().top;
                if (scrolled + win_height_padded < offsetTop) {
                    $(element).removeClass('animated fadeIn')
                }
            });
        }

        $window.on('scroll', revealOnScroll);
        revealOnScroll();
    },

    adjustMediaToContent: () => {
        $('.wsn-banner-module').each((index, element) => {
            const mediaHeight = $(element).find('video') && $(element).find('video').height();
            const contentHeight = $(element).find('.bg-overlay') && $(element).find('.bg-overlay').height();
            if(contentHeight && mediaHeight && mediaHeight < contentHeight) {
                $(element).find('video').addClass('adjust-media-to-content');
            }
        });

        $('.ft-media-wrapper').each((index, element) => {
            const mediaHeight = $(element).find('video') && $(element).find('video').height();
            const mediaWidth = $(element).find('video') && $(element).find('video').width();

            if(mediaHeight && mediaHeight < $(element).height()) {
                $(element).find('video').addClass('ft-adjust-media-to-content');
            }

            if(mediaWidth && mediaWidth < $(element).width()) {
                $(element).find('video').removeClass('ft-adjust-media-to-content');
            }
        });
    },

    initVideoFallback: () => {
        $('.banner-module[data-fallback-img] video').each((index, elem) => {
            const errorHandler = () => {
                const banner = $(elem).closest('.banner-module');
                banner.css('background-image', `url(${banner.data('fallback-img')})`);
            }
            $(elem).find('source').on("error", errorHandler);
            $(elem).on("error", errorHandler);
        });
    },

    rateMateRedirection: () => {
        if(window.location.pathname.startsWith('/ratemate')) {
            window.addEventListener('message', msg => {
                if(msg && msg.data && msg.data.meetingBookSucceeded) {
                    setTimeout(() => {
                        window.location = window.location.origin + '/ratemate/booking-confirmed';
                    }, 500);
                }
            });
        }
    }
}
},{}],4:[function(require,module,exports){
const { http } =  require('./../jobs/http');

module.exports = {
    navbarResizer: () => {
        if ($(window).outerWidth() <= 1259) {
            $('nav').addClass('mobile-nav');
        } else {
            $('nav').removeClass('mobile-nav');
        }

        if (!$('.nav a').hasClass('dropdown-toggle')) {
            $('.nav a').on('click', () => {
                if($('.navbar-toggle').css('display') != 'none'){
                    $(".navbar-toggle").trigger( "click" );
                }
            });
        }
    },

    navbarInit: () => {
        // Bugfix for iOS not scrolling on open menu
        $(".navbar-collapse").css({ maxHeight: $(window).height() - $(".navbar-header").height() + "px" });
        $(".navbar-toggle").click((e) => {
            const header = $(e.target.parentNode.parentNode.parentNode);
            const navlayer = $('.nav-layer');
            if(header.hasClass('open')){
                navlayer.removeClass('shown');
                header.removeClass('open');
                $(document).scrollTop() < 10 && header.removeClass('navbar-scrolling');
            }
            else{
                navlayer.addClass('shown');
                header.addClass('open');
                header.addClass('navbar-scrolling');
            }
        });

        $('.nav-layer').click(e => {
            const header = $('.navbar')
            const navlayer = $('.nav-layer');
            if(header.hasClass('open')){
                navlayer.removeClass('shown');
                header.removeClass('open');
                $('.navbar-collapse').removeClass('in');
                $('.navbar-toggle').addClass('collapsed');
                $(document).scrollTop() < 10 && header.removeClass('navbar-scrolling');
            }   
        })

        // http('GET',  'api/job?is_published_on_widget=1', {}, JSON.parse) // get all jobs
        //     .then(response => {
        //         const jobs = response.data;
        //         const text = $('[href="/career"].dropdown-toggle').text();
        //         const parent_li = $('[href="/career"].dropdown-toggle').parent('li');
        //         $('[href="/career"].dropdown-toggle').append(`<span class="careers-number">${jobs.length}</span>`);
        //         $('.careers-number').css('left', (text.length * 13) - 2 + 'px');
        //     })
    },

    navbarScrollHandler: (scrollTop) => {
        scrollTop > 100 ? $('.navbar').addClass('navbar-scrolling') : $('.navbar').removeClass('navbar-scrolling');
    }
}
},{"./../jobs/http":10}],5:[function(require,module,exports){
module.exports =  () => {
    $.fn.hoverDelay = function(options) {
        var defaultOptions = {
            delayIn: 300,
            delayOut: 300,
            handlerIn: function(){},
            handlerOut: function(){}
        };
        options = $.extend(defaultOptions, options);
        return this.each(function() {
            var timeoutIn, timeoutOut;
            var $element = $(this);
                $element.hover(
                    function() {
                    if (timeoutOut){
                    clearTimeout(timeoutOut);
                    }
                    timeoutIn = setTimeout(function(){options.handlerIn($element);}, options.delayIn);
                    },
                    function() {
                    if (timeoutIn){
                    clearTimeout(timeoutIn);
                    }
                    timeoutOut = setTimeout(function(){options.handlerOut($element);}, options.delayOut);
                    }
                );
        });
    };

    $('.navbar-inverse').hoverDelay({
        delayIn: 100,
        delayOut: 400,
        handlerIn: function($element){
            if($(window).outerWidth() > 1259 && $(document).scrollTop() < 100) {
                $element.addClass("navbar-scrolling");
            }
        },
        handlerOut: function($element){
            if($(window).outerWidth() > 1259 && $(document).scrollTop() < 100) {
                $element.removeClass("navbar-scrolling");
            }
        }
    });

    $('.navbar-nav li.dropdown').hoverDelay({
        delayIn: 300,
        delayOut: 300,
        handlerIn: function($element){
            if($(window).outerWidth() > 1259) {
                $element.addClass("dropdown-open");
            }
        },
        handlerOut: function($element){
            if($(window).outerWidth() > 1259) {
                $element.removeClass("dropdown-open");
            }
        }
    });

    $('.submenu-level1 > li').hover($.debounce(250, function(){
        if($(window).outerWidth() > 1259) {
            var ele = $(this);
            $('.submenu-level2').css({"display": "none"});
            ele.find('.submenu-level2').css({"display": "block"});
        }
    }), null);

    $('.navbar-nav li.dropdown > a').on('click tap',function () {
        if(jQuery(window).outerWidth() < 1260) {
            if (jQuery(this).parent().hasClass('dropdown-open')) {
                $(this).parent().removeClass('dropdown-open');
            } 
            else {
                $('li.dropdown').removeClass('dropdown-open');
                $(this).parent().addClass('dropdown-open');
            }
        }
    });

    $(".submenu-level1 > li > a").on('click tap',function(e) {
        if(jQuery(window).outerWidth() < 1260) {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
            } 
            else {
                $('.submenu-level1>li').removeClass('active');
                $(this).addClass("active");
            }
            e.stopPropagation();
        }
        else {
            $('.submenu-level1 > li > a').removeClass('active');
            $(this).addClass('active');
        }
    });

    $('.mega-close').click( function(e){
        $('.dropdown').removeClass('dropdown-open');
        e.stopPropagation();
    });

    // for showing active menu on load.
    $('.submenu-level1').each(function(){
        $(this).find('> li > a').each(function() {
            let link = $(this).attr('href');
            link = link && link.trim();
            if(link && link != '#' && location.href.endsWith(link)) {
                $(this).addClass('active');
                jQuery(window).outerWidth() > 1259 && $(this).siblings('.submenu-level2').css({"display": "block"});
            }
        });

        $(this).find('> li > a.active').length && $(this).closest('.dropdown').find('.dropdown-toggle').addClass('active');
        
        if(!$(this).find('> li > a.active').length && jQuery(window).outerWidth() > 1259) {
            $(this).find('> li > a').first().addClass('active');
            $(this).find('> li > a').first().siblings('.submenu-level2').css({"display": "block"});
        } 
    });
};

},{}],6:[function(require,module,exports){
const setUpHubspotGATracking = () => {
    window.addEventListener('message', msg => {
        if(msg && msg.data && msg.data.type=="hsFormCallback" && msg.data.eventName =="onFormSubmit") {
          ga('send', 'event', 'ratemate', 'click', 'contact', 'submit')
        }
        if(msg && msg.data && msg.data.meetingBookSucceeded) {
          ga('send', 'event', 'ratemate', 'click', 'bookmeeting', 'submit')
        }
    });
}

const setUpGA = () => {
    (function(i,s,o,g,r,a,m){i["GoogleAnalyticsObject"]=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,"script","https://www.google-analytics.com/analytics.js","ga");
    ga("create", "UA-50286733-2", {"cookieDomain":"auto"});
    ga("set", "anonymizeIp", true);
    ga("send", "pageview");
    setUpHubspotGATracking();
    setUpHubSpotTracking()
}

const setUpCookieBot = () => {
    let script = document.createElement('script');
    script.setAttribute('id', 'Cookiebot');
    script.type = 'text/javascript';
    script.src = 'https://consent.cookiebot.com/uc.js';
    script.setAttribute('async', 'async');
    script.setAttribute('data-cbid', '6bb762ab-746c-4d54-ab7b-94d89fe28138');
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
}

const setUpHubSpotTracking = () => {
    let script = document.createElement('script');
    script.setAttribute('id', 'hs-script-loader');
    script.type = 'text/javascript';
    script.src = 'https://js.hs-scripts.com/5051839.js';
    script.setAttribute('async', 'async');
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
}

// currently we always trigger GA on CookiebotOnAccept as consent is active only.
const setUpTrackingFallback = () => {
    if (!window.google_tag_manager) {
        setUpCookieBot();
        window.addEventListener('CookiebotOnAccept', setUpGA, false);
    }
}

module.exports = setUpTrackingFallback;

},{}],7:[function(require,module,exports){
const getCurrentLang = () => window.drupalSettings && window.drupalSettings.path ?
window.drupalSettings.path.currentLanguage : 'en'

const Translations = {
  en: {
    days: 'days',
    day: 'day',
    hour: 'hour',
    hours: 'hours',
    minute: 'minute',
    minutes: 'minutes',
    second: 'second',
    seconds: 'seconds',
  },
  de: {
    days: 'tage',
    day: 'tag',
    hour: 'stunde',
    hours: 'stunden',
    minute: 'minute',
    minutes: 'minuten',
    second: 'sekunde',
    seconds: 'sekunden',
  }
}

const getTranslations = key => Translations[getCurrentLang()][key]

module.exports = getTranslations

},{}],8:[function(require,module,exports){
const getTranslation = require("./translations");

module.exports = {
  initScroller: () => {
    $("#navbar").localScroll({
      easing: "easeInOutExpo",
    });

    $("#page-top").localScroll({
      easing: "easeInOutExpo",
    });
  },

  initScrollforLocalLinks: () => {
    const anchors = Array.from(document.getElementsByTagName("a"));
    const localLinks = anchors.filter((anchor) => {
      const href = anchor.href;
      return href && href.startsWith("#") && href.length > 1 && $(href).length;
    });
    const smoothScrollHandler = (id) => () =>
      smoothScroll(document.getElementById(id));
    localLinks.forEach((anchor) => {
      anchor.addEventListner.on(
        "click",
        smoothScrollHandler(anchor.href.trim("#"))
      );
      anchor.addEventListner.on(
        "touchend",
        smoothScrollHandler(anchor.href.trim("#"))
      );
    });
  },

  initParallax: () => {
    const isSafari =
      /Safari/.test(navigator.userAgent) &&
      /Apple Computer/.test(navigator.vendor);
    if (!isSafari) {
      $(".main-op").parallax("50%", 0.2);
      $(".number-counters").parallax("50%", 0.2);
      $(".cirlce-counters").parallax("50%", 0.3);
      $(".client-list-parallax").parallax("50%", 0.4);
      $(".testimonials-parallaxx").parallax("50%", 0.4);
      $(".twitter-slider").parallax("50%", 0.4);
      $(".login-2").parallax("50%", 0.2);
    }
  },

  initCountCirc: () => {
    $(".circle-counters").each((index, elem) => {
      const waypoint = new Waypoint({
        element: $(elem),
        handler: () => {
          const options = {
            useEasing: true,
            separator: "",
          };

          $(elem)
            .find(".chart")
            .easyPieChart({
              size: "150",
              lineWidth: 3,
              lineCap: "square",
              trackColor: "",
              barColor: "#f8f8f8",
              scaleColor: false,
              easing: "easeOutBack",
              animate: {
                duration: 2000,
                enabled: true,
              },
            });
          // init only once
          waypoint && waypoint.destroy();
        },
        offset: "70%",
      });
    });
  },

  initCountNbr: () => {
    $(".number-counters").each((index, element) => {
      const waypoint = new Waypoint({
        element: $(element),
        handler: () => {
          // only on children
          $(element)
            .find(".number")
            .each((index, elem) => {
              const countTo = $(elem).data("countTo");
              const precision = $(elem).data("precision") || "0";
              const decimalSeparator = $(elem).data("decimalSeparator") || ".";
              const thausandSeparator =
                $(elem).data("thausandSeparator") || ",";

              $({ countNum: $(elem).text() }).animate(
                {
                  countNum: countTo,
                },
                {
                  duration: 2000,
                  easing: "linear",
                  step: (val) => {
                    $(elem).text(
                      $.number(
                        val,
                        parseInt(precision),
                        decimalSeparator,
                        thausandSeparator
                      )
                    );
                  },
                  complete: () => {
                    $(elem).text(
                      $.number(
                        countTo,
                        parseInt(precision),
                        decimalSeparator,
                        thausandSeparator
                      )
                    );
                  },
                }
              );
            });
          waypoint && waypoint.destroy();
        },
        offset: "70%",
      });
    });
  },

  initSliders: () => {
    // Features Slider
    $(".ft-slider").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="info-slider-nav slick-prev"><i class="fa fa-long-arrow-left"></i></button>',
      nextArrow:
        '<button type="button" class="info-slider-nav slick-next"><i class="fa fa-long-arrow-right"></i></button>',
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
          },
        },
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // Testimonials Sliders
    $(".t-slider").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="t-slider-nav slick-prev"><span class="linea-arrows-slim-left"></span></button>',
      nextArrow:
        '<button type="button" class="t-slider-nav slick-next"><span class="linea-arrows-slim-right"></span></button>',
    });

    // Global Slider
    $(".global-slider").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      swipeToSlide: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      variableWidth: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
          },
        },
        {
          breakpoint: 384,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
          },
        },
      ],
    });

    // Brands/Clients Slider
    $(".clients-slider").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 9,
      // slidesToScroll: 1,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3,
            // slidesToScroll: 2,
            infinite: true,
          },
        },
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 2,
            // slidesToScroll: 1
          },
        },
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 1,
            // slidesToScroll: 1
          },
        },
      ],
    });

    $(".company-slider").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      swipeToSlide: true,
      slidesToShow: 4,
      // centerMode: true,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      variableWidth: false,
      infinite: true,

      responsive: [
        {
          breakpoint: 992,
          settings: {
            variableWidth: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 512,
          settings: {
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
      ],
    });

    $(".certification").slick({
      autoplay: true,
      autoplaySpeed: 1000,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
    });

    $(".pc-slider").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="pc-slider-nav slick-prev"><span class="linea-arrows-left"></span></button>',
      nextArrow:
        '<button type="button" class="pc-slider-nav slick-next"><span class="linea-arrows-right"></span></button>',
      responsive: [
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    $(".work-slider").slick({
      autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      prevArrow:
        '<button type="button" class="slick-prev"><span class="fa fa-caret-left"></span></button>',
      nextArrow:
        '<button type="button" class="slick-next"><span class="fa fa-caret-right"></span></button>',
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
          },
        },
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
          },
        },
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
          },
        },
      ],
    });

    // Portfolio Single Slider
    $(".single-img-slider").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="slider-nav sl-prev"><span class="linea-arrows-slim-left"></span></button>',
      nextArrow:
        '<button type="button" class="slider-nav sl-next"><span class="linea-arrows-slim-right"></span></button>',
    });

    // Centered Gallery
    $(".centered-gallery").slick({
      centerMode: true,
      centerPadding: "60px",
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "40px",
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "40px",
            slidesToShow: 1,
          },
        },
      ],
    });

    // Text Slider
    $(".text-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      speed: 300,
      fade: true,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><span class="linea-arrows-slim-left"></span></button>',
      nextArrow:
        '<button type="button" class="slick-next"><span class="linea-arrows-slim-right"></span></button>',
      autoplay: true,
      autoplaySpeed: 4000,
    });

    // Shop Product Slider
    $(".shop-p-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      speed: 300,
      // fade: false,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="shop-p-slider-nav shop-p-slider-nav-left"><span class="linea-arrows-slim-left"></span></button>',
      nextArrow:
        '<button type="button" class="shop-p-slider-nav shop-p-slider-nav-right"><span class="linea-arrows-slim-right"></span></button>',
      autoplay: false,
    });

    // Shop Product Single - Slider
    $(".prod_single_img_slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      speed: 300,
      // fade: false,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="shop-p-slider-nav shop-p-slider-nav-left"><span class="linea-arrows-slim-left"></span></button>',
      nextArrow:
        '<button type="button" class="shop-p-slider-nav shop-p-slider-nav-right"><span class="linea-arrows-slim-right"></span></button>',
      autoplay: false,
      accessibility: false,
      customPaging: (slider, i) => {
        return (
          '<a href="#">' +
          $(".prod_single_thumbs_slider li:nth-child(" + (i + 1) + ")").html() +
          "</a>"
        );
      },
    });
  },

  initPortfolio: () => {
    // Filters
    $(".portfolio-filters a").click((e) => {
      e.preventDefault();
      $(".portfolio-filters li").removeClass("active");
      $(e.currentTarget).parent().addClass("active");
    });

    // Full Width Gallery (3 columns)
    const pfolio3colFW = () => {
      const $container = $("#pfolio");
      $container.isotope({
        itemSelector: ".portfolio-item",
      });

      // Filter items
      $("#pfolio-filters").on("click", "a", (e) => {
        var filterValue = $(e.currentTarget).attr("data-filter");
        $container.isotope({ filter: filterValue });
      });
    };

    const pfolioMasonry = () => {
      const $container = $(".portfolio-items");
      $container.isotope({
        itemSelector: ".img-block",
        percentPosition: true,
        layoutMode: "packery",
        masonry: {
          columnWidth: ".grid-sizer",
        },
      });

      // Filter items
      $(".portfolio-filters").on("click", "a", (e) => {
        const itemList = $(e.currentTarget)
          .closest(".dynamic-image-section")
          .find(".portfolio-items");
        const filterValue = $(e.currentTarget).attr("data-filter");
        itemList.isotope({ filter: filterValue });
      });
    };

    pfolio3colFW();
    pfolioMasonry();
    $(".dynamic-image-section").css("visibility", "visible");
  },

  initGallery: () => {
    // Image Lightbox
    const hasPopup = $("a").hasClass("open-gallery");
    if (hasPopup) {
      $(".open-gallery").magnificPopup({
        type: "image",
        gallery: {
          enabled: true,
        },
      });
    }

    // Footer Gallery Lightbox
    const hasFtPopup = $("a").hasClass("gallery-widget-lightbox");
    if (hasFtPopup) {
      $(".gallery-widget-lightbox").magnificPopup({
        type: "image",
        gallery: {
          enabled: true,
        },
      });
    }

    // Video Lightbox
    const hasVideoPopup = $("a").hasClass("popup-video");
    if (hasVideoPopup) {
      $(".popup-video").magnificPopup({
        disableOn: 0,
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      });
    }
  },

  initBlogMasonry: () => {
    const $container = $(".blog-container");
    $container.isotope({
      itemSelector: ".blog-selector",
      percentPosition: true,
    });
  },

  initVideoOnImageGrid: () => {
    $(".img-block").each((index, element) => {
      $(element).hover(
        (e) => {
          const video = $(element).find("video");
          video.length && $(video[0]).addClass("play");
          video.length && video[0].play();
        },
        (e) => {
          const video = $(element).find("video");
          video.length && $(video[0]).removeClass("play");
          video.length && video[0].pause();
        }
      );
    });

    $(".play-icon").click((e) => {
      const video = $(e.currentTarget.parentNode.parentNode).find("video");
      if (video.length) {
        $(video[0]).addClass("play");
        $(video[0]).attr("controls", "");
        $(video[0]).onpause = (e) => {
          $(e.currentTarget).removeClass("play");
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }
        };
        video[0].play();
        if (video[0].requestFullscreen) {
          video[0].requestFullscreen();
        } else if (video[0].mozRequestFullScreen) {
          video[0].mozRequestFullScreen();
        } else if (video[0].webkitRequestFullscreen) {
          video[0].webkitRequestFullscreen();
        } else if (video[0].msRequestFullscreen) {
          video[0].msRequestFullscreen();
        }
      }
    });
  },

  initVideoOnBannerModuleThin: () => {
    // Video Lightbox
    var hasVideoPopup = $("a").hasClass("popup-video");

    if (hasVideoPopup) {
      $(".popup-video").magnificPopup({
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false,
      });
    }
  },

  initFT_Tabs: () => {
    $(".ft-tabs-dark .tabs-list li:first").addClass("active");
    $(".ft-tabs .tabs-list li:first").addClass("active");
    $(".tab-content .tab-pane:first").addClass("in active");
    $(".ft-tabs .tab-content .tab-pane:first").addClass("in active");

    $('a[data-toggle="tab"]').on("shown.bs.tab", (event) => {
      const id = $(event.target).data("target");
      const current_ft_tabs = $(event.target).closest(
        ".ft-tabs, .ft-tabs-dark"
      );
      const tab_info_image = $(current_ft_tabs).find(id + " .tab-info-image");
      const tab_content_image = $(current_ft_tabs).find(
        id + " .tab-content-image"
      );

      $(current_ft_tabs).find(".tab-content-image").removeClass("animated");
      $(current_ft_tabs).find(".tab-info-image").removeClass("animated");
      tab_info_image.length && tab_info_image.addClass("animated");
      tab_info_image.length && tab_info_image.attr("style", "");
      tab_content_image.length && tab_content_image.addClass("animated");
      tab_content_image.length && tab_content_image.attr("style", "");
    });
  },
  initNewTabs: () => {
    $(".tabs-menu a").on("click", function (event) {
      event.preventDefault();
      // Toggle active class on tab buttons
      $(this).parent().addClass("active");
      $(this).parent().siblings().removeClass("active");

      // display only active tab content
      var activeTab = $(this).attr("data-target");
      $(".tab-content").not(activeTab).css("display", "none");
      $(activeTab).fadeIn();
    });
  },
  initAccordion: () => {
    $(".accordion__container").each((index, element) => {
      $(element).on("click", (event) => {
        $(element).toggleClass("active");
      });
    });
  },
  initCountdown: () => {
    $(".wsn-countdown").length &&
      $(".wsn-countdown").each((index, element) => {
        $(element).countdown(
          {
            date: $(element).data("countdown"),
            day: getTranslation("day"),
            days: getTranslation("days"),
            hour: getTranslation("hour"),
            hours: getTranslation("hours"),
            minute: getTranslation("minute"),
            minutes: getTranslation("minutes"),
            second: getTranslation("second"),
            seconds: getTranslation("seconds"),
          },
          () => {
            $(element).hide();
          }
        );
      });
  },
};

},{"./translations":7}],9:[function(require,module,exports){
if (!$) $ = jQuery;

const initNewMenu = require("./components/new-menu");
const smoothScroll = require("smoothscroll");
const {
  navbarInit,
  navbarResizer,
  navbarScrollHandler,
} = require("./components/navbar");
const {
  initBlogMasonry,
  initPortfolio,
  initParallax,
  initGallery,
  initScroller,
  initScrollforLocalLinks,
  initCountCirc,
  initCountNbr,
  initSliders,
  initFT_Tabs,
  initNewTabs,
  initAccordion,
  initCountdown,
  initVideoOnImageGrid,
  initVideoOnBannerModuleThin,
} = require("./components/widget");

const {
  highlightWhenVisible,
  initVideoBg,
  initScrollReveal,
  adjustMediaToContent,
  initVideoFallback,
  rateMateRedirection,
} = require("./components/miscellaneous");

const setUpTrackingFallback = require("./components/tracker-blocking-fallback");
const kenburnsInit = require("./components/kenburns-init");

$(document).ready(function () {
  setUpTrackingFallback();
  initNewMenu();
  navbarInit();
  initScroller();
  initScrollforLocalLinks();
  initSliders();
  initGallery();
  initVideoBg();
  initVideoOnImageGrid();
  initVideoOnBannerModuleThin();
  initVideoFallback();
  kenburnsInit();

  if ($(window).width() >= 1260) {
    initParallax();
  }

  if ($(window).width() <= 600) {
    highlightWhenVisible($(".ft-boxed-hover ul li"));
  }

  initScrollReveal();

  // waypoint based triggers should be registered at the very end.
  initBlogMasonry();
  initCountCirc();
  initCountNbr();
  initCountdown();
  rateMateRedirection();

  new WOW().init();

  $(".jarvis-popup-video").length &&
    $(".jarvis-popup-video").magnificPopup({
      disableOn: 0,
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: true,
      fixedContentPos: false,
    });

  $(".preloader img").fadeOut(); // will first fade out the loading animation
  $(".preloader")
    .delay(350)
    .fadeOut("slow", function () {});
});

$(window).on("load", function () {
  initFT_Tabs();
  initNewTabs();
  initAccordion();
  adjustMediaToContent();
  initPortfolio();
});

$(window).resize(
  $.debounce(750, function () {
    adjustMediaToContent();
    navbarResizer();
  })
);

$(window).scroll(
  $.debounce(100, function () {
    navbarScrollHandler($(document).scrollTop());
  })
);

// $('.show-map').on('click', function(e){
//     e.preventDefault();
//     $('.contact-info-wrapper').toggleClass('map-open');
//     $('.show-info-link').toggleClass('info-open');
//   });

//   $('.show-info-link').on('click', function(e){
//     e.preventDefault();
//     $('.contact-info-wrapper').toggleClass('map-open');
//     $(this).toggleClass('info-open');
//   });

},{"./components/kenburns-init":2,"./components/miscellaneous":3,"./components/navbar":4,"./components/new-menu":5,"./components/tracker-blocking-fallback":6,"./components/widget":8,"smoothscroll":1}],10:[function(require,module,exports){
const http = (method, url, headers, data, data_transform_func) => new Promise((resolve, reject) => {
    const data_transformation = data => data_transform_func ? data_transform_func(data) : data;
    const xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open(method, url, true);
    
    let key = '';
    for(key in headers) {
        xhr.setRequestHeader(key, headers[key]);
    }

    xhr.onreadystatechange = () => {
        xhr.status === 200 && xhr.readyState === 4 && resolve(data_transformation(xhr.responseText));
        xhr.status >= 300 && reject(xhr.status);
    }

    xhr.send(data);
});

module.exports = {
    http: http
}


},{}]},{},[9])